'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dEnum$002dSample$0024package$0024$002dColor$00241 from "./samples.-Enum-Sample$package$-Color$1.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$$anon$5(evaluator$8) {
  this.L7 = null;
  this.L7 = evaluator$8;
}
export { $c_Lsamples_EnumSample$package$$anon$5 as $c_Lsamples_EnumSample$package$$anon$5 };
$p = $c_Lsamples_EnumSample$package$$anon$5.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$$anon$5;
/** @constructor */
function $h_Lsamples_EnumSample$package$$anon$5() {
}
export { $h_Lsamples_EnumSample$package$$anon$5 as $h_Lsamples_EnumSample$package$$anon$5 };
$h_Lsamples_EnumSample$package$$anon$5.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.L7.h();
  return ((v instanceof $j_samples$002e$002dEnum$002dSample$0024package$0024$002dColor$00241.$c_Lsamples_EnumSample$package$Color$1) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_EnumSample$package$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$$anon$5, "samples.EnumSample$package$$anon$5", ({
  oU: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EnumSample$package$$anon$5 as $d_Lsamples_EnumSample$package$$anon$5 };
